import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, message,Progress,notification,Popover} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},
    {key:'progressCode', label: '编号', width: 140},
    {key:'progressName', label: '名称', width: 400 ,render: (value,row) =>
    <span> 
        <Popover placement="topLeft" style={{ width: 300 }}  content={
            <div style={{ width: 200 }}>
                {
                    row.categoryPathStr
                }
            </div>} 
            title="分类路径"
            >
            {value}
        </Popover>
    </span> 
    },
    {key:'yearName', label: '年度'},
    {key:'progressValue', label: '任务进度' ,
            render:(value) => <Progress percent={parseInt(value)} />  },
    // {key:'budgetValue', label: '预算'},
    {key:'expenseValue', label: '经费（元）', width: 100},
    // {key:'expenseProgress', label: '经费执行进度' ,
    //         render:(value) => <Progress percent={parseInt(value)} />  },
    {key:'importObj', label: '数据来源', width: 100},
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('supv/progress/query', keywords)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta
        };
    })
    .then(res => (Object.assign({
        result: res.data.dataList || [],
        selects: (res.data.dataList || []).map(d => ({
            value: d.id,
            checked: false,
            name: d.taskName
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const querySearchById = (id) => {
    return fetch.get('supv/progress/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        console.log('error');
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('supv/progress/update/' + id, data)
    .then(response => {
        Modal.success({
            title: '提示信息',
            content: (
                <div>
                    <p>{response.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {
                DataGrid.selections = [];
            },
        });
        
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('supv/progress/remove/', ids)
    .then(response => {
        return response;
    });
}


/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
 const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.selectData = [];
                                DataGrid.refresh();
                                callback();
                            },
                        });
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'employee'+ url;
};

const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

const createQueryData = (keywords = {}) => {
    return fetch.post('supv/progress/standardStat', keywords)
    .then((response) => {
       return response;
    })
}

const checkInput = () => {
    return fetch.get('supv/progress/checkInput', {})
    .then(response => response.payload.data)
    .catch(error => {
        console.log('error');
    });
}

export default {
    querySearch,
    columns,
    onSelect,
    batchRemove,
    update,
    createQueryData,
    onSelectData,
    setRefresh,
    redirect,
    getSelection,
    getSelectionData,
    querySearchById,
    checkInput
}